import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:parcel',
      component: () => import('./views/ParcelDetail'),
    },
  ],
})
